// import React, { useCallback, useEffect, useState } from "react";
// import { Input, FormGroup, Button, Label } from "reactstrap";
// import { CustomButton } from "components/CommonInputs/CustomButtons/CustomButton";
// import { useNavigate } from "react-router-dom";
// import { post } from "helpers/api_helper";
// import { GET_ALL_TEMPLATE } from "constants/api_constants";

// const NewJobPost = ({ closeModal }) => {
//   const [selectedOption, setSelectedOption] = useState("");
//   const [selectedTemplateId, setSelectedTemplateId] = useState("");
//   const [templatesData, setTemplatesData] = useState([]);
//   const [apiStatus, setApiStatus] = useState({ loading: false, error: "" });

//   const navigate = useNavigate();

//   const handleContinue = () => {
//     console.log("handleContinue called, selectedOption:", selectedOption);
//     console.log("Selected Template ID:", selectedTemplateId);

//     if (selectedOption === "existing") {
//       navigate("/existing-new-job", { state: { templateId: selectedTemplateId } });
//     } else if (selectedOption === "new") {
//       navigate("/create-new-job");
//     } else {
//       console.log("Closing modal, no option selected");
//       closeModal();
//     }
//   };

//   useEffect(() => {
//     fetchTemplates();
//   }, []);

//   const fetchTemplates = useCallback(async () => {
//     try {
//       setApiStatus({ loading: true, error: "" });
//       const response = await post(GET_ALL_TEMPLATE, {
//         searchKeyword: "",
//         department: "",
//         status: null,
//         page: 0,
//         pageSize: 100,
//         orderBy: "templateName",
//         sort: "desc",
//       });

//       console.log("response", response);
//       setTemplatesData(response?.data?.data || []);
//     } catch (error) {
//       console.error("Error fetching templates:", error);
//       setApiStatus({ loading: false, error: "Failed to fetch templates" });
//     }
//   }, []);

//   return (
//     <div style={{ padding: "22px", gap: "24px" }}>
//       <p
//         className="heading"
//         style={{
//           fontWeight: 700,
//           fontSize: "24px",
//           lineHeight: "28px",
//           marginBottom: "24px",
//         }}
//       >
//         Create New Job Post
//       </p>

//       <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
//         {/* Existing Template Section */}
//         <div
//           style={{
//             borderRadius: "12px",
//             padding: "20px",
//             backgroundColor: "#f8f9fa",
//             gap: "20px",
//           }}
//         >
//           <FormGroup check>
//             <Input
//               type="radio"
//               name="candidateOption"
//               id="existingCandidates"
//               value="existing"
//               onChange={(e) => setSelectedOption(e.target.value)}
//               style={{ border: "0.1px solid black", cursor: "pointer" }}
//             />
//             <Label
//               check
//               for="existingCandidates"
//               className="ms-2"
//               style={{ fontWeight: 500, fontSize: "14px" }}
//             >
//               Select From Existing Template
//             </Label>
//           </FormGroup>

//           <Label
//             className="mt-3"
//             for="selectTemplate"
//             style={{
//               fontFamily: "Inter, sans-serif",
//               fontWeight: 500,
//               fontSize: "14px",
//               lineHeight: "20px",
//             }}
//           >
//             Select Template
//           </Label>

//           <Input
//             type="select"
//             id="selectTemplate"
//             value={selectedTemplateId}
//             onChange={(e) => setSelectedTemplateId(e.target.value)}
//             disabled={selectedOption !== "existing"}
//           >
//             <option value="">Select</option>
//             {templatesData.map((template) => (
//               <option key={template.tId} value={template.templateName}>
//                 {template.templateName}
//               </option>
//             ))}
//           </Input>
//         </div>

//         {/* Create New Template Section */}
//         <div
//           style={{
//             borderRadius: "12px",
//             padding: "20px",
//             backgroundColor: "#f8f9fa",
//           }}
//         >
//           <FormGroup check>
//             <Input
//               type="radio"
//               name="candidateOption"
//               id="newCandidates"
//               value="new"
//               onChange={(e) => setSelectedOption(e.target.value)}
//               style={{ border: "0.1px solid black", cursor: "pointer" }}
//             />
//             <Label
//               check
//               for="newCandidates"
//               className="ms-2"
//               style={{ fontWeight: 500, fontSize: "14px" }}
//             >
//               Create New
//             </Label>
//           </FormGroup>
//         </div>
//       </div>

//       {/* Action Buttons */}
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "flex-end",
//           marginTop: "24px",
//         }}
//       >
//         <Button
//           className="text-primary border-primary"
//           onClick={closeModal}
//           style={{
//             backgroundColor: "white",
//             border: "1px solid primary",
//             borderRadius: "6px",
//             marginRight: "16px",
//           }}
//         >
//           Cancel
//         </Button>
//         <CustomButton text={"Continue"} onClick={handleContinue} />
//       </div>
//     </div>
//   );
// };

// export default NewJobPost;

import React, { useCallback, useEffect, useState } from "react";
import { Input, FormGroup, Button, Label } from "reactstrap";
import { CustomButton } from "components/CommonInputs/CustomButtons/CustomButton";
import { useNavigate } from "react-router-dom";
import { post } from "helpers/api_helper";
import { GET_ALL_TEMPLATE } from "constants/api_constants";

const NewJobPost = ({ closeModal }) => {
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedTemplateId, setSelectedTemplateId] = useState("");
  const [templatesData, setTemplatesData] = useState([]);
  console.log("TemplData",templatesData);
  
  const [apiStatus, setApiStatus] = useState({ loading: false, error: "" });

  const navigate = useNavigate();

  const handleContinue = () => {
    // console.log("handleContinue called, selectedOption:", selectedOption);
    // console.log("Selected Template ID:", selectedTemplateId);

    if (selectedOption === "existing") {
      navigate("/existing-new-job", { state: { tId: selectedTemplateId } });
    } else if (selectedOption === "new") {
      navigate("/create-new-job");
    } else {
      // console.log("Closing modal, no option selected");
      closeModal();
    }
  };

  useEffect(() => {
    fetchTemplates();
  }, []);

  const fetchTemplates = useCallback(async () => {
    try {
      setApiStatus({ loading: true, error: "" });
      const response = await post(GET_ALL_TEMPLATE, {
        searchKeyword: "",
        department: "",
        status: null,
        page: 0,
        pageSize: 100,
        orderBy: "templateName",
        sort: "desc",
      });

      // console.log("response", response);
      setTemplatesData(response?.data?.data || []);
    } catch (error) {
      console.error("Error fetching templates:", error);
      setApiStatus({ loading: false, error: "Failed to fetch templates" });
    }
  }, []);

  return (
    <div style={{ padding: "22px", gap: "24px" }}>
      <p
        className="heading"
        style={{
          fontWeight: 700,
          fontSize: "24px",
          lineHeight: "28px",
          marginBottom: "24px",
        }}
      >
        Create New Job Post
      </p>

      <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        {/* Existing Template Section */}
        <div
          style={{
            borderRadius: "12px",
            padding: "20px",
            backgroundColor: "#f8f9fa",
            gap: "20px",
          }}
        >
          <FormGroup check>
            <Input
              type="radio"
              name="candidateOption"
              id="existingCandidates"
              value="existing"
              onChange={(e) => setSelectedOption(e.target.value)}
              style={{ border: "0.1px solid black", cursor: "pointer" }}
            />
            <Label
              check
              for="existingCandidates"
              className="ms-2"
              style={{ fontWeight: 500, fontSize: "14px" }}
            >
              Select From Existing Template
            </Label>
          </FormGroup>

          <Label
            className="mt-3"
            for="selectTemplate"
            style={{
              fontFamily: "Inter, sans-serif",
              fontWeight: 500,
              fontSize: "14px",
              lineHeight: "20px",
            }}
          >
            Select Template
          </Label>

          <Input
            type="select"
            id="selectTemplate"
            value={selectedTemplateId}
            onChange={(e) => setSelectedTemplateId(e.target.value)}
            disabled={selectedOption !== "existing"}
          >
            <option value="">Select</option>
            {templatesData.map((template) => (
              <option key={template.tid} value={template.tid}>
                {template.templateName}
              </option>
            ))}
          </Input>
        </div>

        {/* Create New Template Section */}
        <div
          style={{
            borderRadius: "12px",
            padding: "20px",
            backgroundColor: "#f8f9fa",
          }}
        >
          <FormGroup check>
            <Input
              type="radio"
              name="candidateOption"
              id="newCandidates"
              value="new"
              onChange={(e) => setSelectedOption(e.target.value)}
              style={{ border: "0.1px solid black", cursor: "pointer" }}
            />
            <Label
              check
              for="newCandidates"
              className="ms-2"
              style={{ fontWeight: 500, fontSize: "14px" }}
            >
              Create New
            </Label>
          </FormGroup>
        </div>
      </div>

      {/* Action Buttons */}
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "24px",
        }}
      >
        <Button
          className="text-primary border-primary"
          onClick={closeModal}
          style={{
            backgroundColor: "white",
            border: "1px solid primary",
            borderRadius: "6px",
            marginRight: "16px",
          }}
        >
          Cancel
        </Button>
        <CustomButton text={"Continue"} onClick={handleContinue} />
      </div>
    </div>
  );
};

export default NewJobPost;